import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { getColorWithOpacity } from "plos/src/styles/colors";
import { vars } from "plos/src/styles/theme.css";

export const navStyles = style({
  backdropFilter: vars.blur[10],
  background: getColorWithOpacity(vars.colors.primaryFixed, 50),
});

export const navListStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.m,
  marginBlock: 0,
  paddingInlineStart: vars.space.m,
  paddingInlineEnd: vars.space.m,
  overflowX: "scroll",
  overflowY: "hidden",
  scrollbarWidth: "none", // Firefox
  msOverflowStyle: "none", // Edge
  selectors: {
    "&::-webkit-scrollbar": {
      display: "none", // Chrome/Safari
    },
  },
});

export const subNavStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.m,
  background: "transparent",
  paddingInlineStart: vars.space.xs,
  color: vars.colors.onSurface,
});

export const navContainerStyles = style({
  margin: "0 auto",
  maxWidth: breakpoints[7],
});
